import type { SVGProps } from '@/types/common.types';

const SubscriptionUzVideoSVG = (props: SVGProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="105"
      height="24"
      viewBox="0 0 105 24"
      fill="none"
      {...props}
    >
      <path
        d="M18.3639 5.63604C21.8787 9.15076 21.8787 14.8492 18.3639 18.3639C14.8492 21.8787 9.15074 21.8787 5.63604 18.3639C2.12132 14.8492 2.12132 9.15074 5.63604 5.63604C9.15076 2.12132 14.8492 2.12132 18.3639 5.63604"
        stroke="#76CEFF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 21H21"
        stroke="#76CEFF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 17V18"
        stroke="#76CEFF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 6V7"
        stroke="#76CEFF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 12H6"
        stroke="#76CEFF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18 12H17"
        stroke="#76CEFF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.5406 15.54L16.2406 16.24"
        stroke="#76CEFF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.75938 7.75999L8.45938 8.45999"
        stroke="#76CEFF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.45938 15.54L7.75938 16.24"
        stroke="#76CEFF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.2406 7.75999L15.5406 8.45999"
        stroke="#76CEFF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.4142 10.5858C14.1953 11.3668 14.1953 12.6332 13.4142 13.4142C12.6332 14.1953 11.3668 14.1953 10.5858 13.4142C9.80474 12.6332 9.80474 11.3668 10.5858 10.5858C11.3668 9.80474 12.6332 9.80474 13.4142 10.5858"
        stroke="#76CEFF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M35.4798 5.63632H38.462V13.6111C38.462 14.5327 38.2427 15.3357 37.804 16.0198C37.3653 16.7 36.7536 17.2272 35.9688 17.6015C35.1839 17.9718 34.2724 18.1569 33.234 18.1569C32.1836 18.1569 31.266 17.9718 30.4812 17.6015C29.6964 17.2272 29.0866 16.7 28.652 16.0198C28.2173 15.3357 28 14.5327 28 13.6111V5.63632H30.9883V13.3515C30.9883 13.7781 31.0808 14.1585 31.266 14.4925C31.4551 14.8265 31.7188 15.0881 32.0568 15.2773C32.3949 15.4665 32.7873 15.561 33.234 15.561C33.6808 15.561 34.0711 15.4665 34.4052 15.2773C34.7433 15.0881 35.0069 14.8265 35.196 14.4925C35.3852 14.1585 35.4798 13.7781 35.4798 13.3515V5.63632Z"
        fill="#76CEFF"
      />
      <path
        d="M40.2927 18V16.2975L46.2994 8.06317H40.2987V5.63632H50.0786V7.33873L44.0718 15.5731H50.0725V18H40.2927Z"
        fill="#76CEFF"
      />
      <path
        d="M54.7134 5.63632L57.4783 14.6917H57.581L60.3459 5.63632H63.6903L59.5188 18H55.5405L51.369 5.63632H54.7134Z"
        fill="#76CEFF"
      />
      <path d="M68.0098 5.63632V18H65.0215V5.63632H68.0098Z" fill="#76CEFF" />
      <path
        d="M74.4557 18H69.8857V5.63632H74.4497C75.7094 5.63632 76.794 5.88383 77.7036 6.37886C78.6172 6.86987 79.3215 7.5782 79.8165 8.50386C80.3115 9.4255 80.559 10.5282 80.559 11.8121C80.559 13.1 80.3115 14.2067 79.8165 15.1324C79.3255 16.0581 78.6232 16.7684 77.7096 17.2635C76.796 17.7545 75.7114 18 74.4557 18ZM72.874 15.4524H74.341C75.0332 15.4524 75.6188 15.3357 76.0977 15.1022C76.5807 14.8648 76.9449 14.4804 77.1904 13.9492C77.44 13.4139 77.5647 12.7015 77.5647 11.8121C77.5647 10.9227 77.44 10.2143 77.1904 9.6871C76.9409 9.15585 76.5727 8.77351 76.0857 8.54008C75.6027 8.30263 75.0071 8.1839 74.2987 8.1839H72.874V15.4524Z"
        fill="#76CEFF"
      />
      <path
        d="M82.3037 18V5.63632H90.9244V8.06317H85.292V10.5987H90.4838V13.0316H85.292V15.5731H90.9244V18H82.3037Z"
        fill="#76CEFF"
      />
      <path
        d="M104.465 11.8181C104.465 13.1785 104.204 14.3315 103.68 15.2773C103.157 16.2231 102.449 16.9415 101.555 17.4325C100.666 17.9235 99.6679 18.169 98.5612 18.169C97.4504 18.169 96.4503 17.9215 95.5608 17.4264C94.6714 16.9314 93.965 16.213 93.4418 15.2713C92.9227 14.3255 92.6631 13.1744 92.6631 11.8181C92.6631 10.4578 92.9227 9.30476 93.4418 8.35898C93.965 7.41319 94.6714 6.69479 95.5608 6.20379C96.4503 5.71279 97.4504 5.46729 98.5612 5.46729C99.6679 5.46729 100.666 5.71279 101.555 6.20379C102.449 6.69479 103.157 7.41319 103.68 8.35898C104.204 9.30476 104.465 10.4578 104.465 11.8181ZM101.411 11.8181C101.411 11.0132 101.296 10.3331 101.066 9.77765C100.841 9.22226 100.515 8.80168 100.089 8.51594C99.6659 8.23019 99.1568 8.08731 98.5612 8.08731C97.9695 8.08731 97.4604 8.23019 97.0338 8.51594C96.6072 8.80168 96.2792 9.22226 96.0498 9.77765C95.8244 10.3331 95.7117 11.0132 95.7117 11.8181C95.7117 12.6231 95.8244 13.3032 96.0498 13.8586C96.2792 14.414 96.6072 14.8346 97.0338 15.1203C97.4604 15.4061 97.9695 15.549 98.5612 15.549C99.1568 15.549 99.6659 15.4061 100.089 15.1203C100.515 14.8346 100.841 14.414 101.066 13.8586C101.296 13.3032 101.411 12.6231 101.411 11.8181Z"
        fill="#76CEFF"
      />
    </svg>
  );
};

export default SubscriptionUzVideoSVG;
